import { auth } from '../firebase';
import { resolveApiBaseUrl } from '../utils/apiBaseUrl';

/**
 * Build request headers, optionally including Firebase ID token.
 * @param {boolean} authenticated
 * @returns {Promise<HeadersInit>}
 */
export async function getApiHeaders(authenticated = false) {
  const headers = { 'Content-Type': 'application/json' };

  if (authenticated) {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('You must be signed in to perform this action');
    }
    const token = await user.getIdToken();
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}

/**
 * Perform a fetch against the Storykin API.
 * @param {string} path - Path starting with /api/
 * @param {RequestInit & { authenticated?: boolean }} options
 */
export async function apiFetch(path, options = {}) {
  const { authenticated = false, headers: extraHeaders, ...rest } = options;
  const headers = {
    ...(await getApiHeaders(authenticated)),
    ...extraHeaders
  };

  const response = await fetch(`${resolveApiBaseUrl()}${path}`, { ...rest, headers });

  if (!response.ok) {
    let message = `HTTP error! status: ${response.status}`;
    let errorCode;
    try {
      const data = await response.json();
      message = data.error || data.message || message;
      errorCode = data.errorCode;
    } catch {
      // ignore parse errors
    }
    const err = new Error(message);
    if (errorCode) err.errorCode = errorCode;
    throw err;
  }

  return response.json();
}

export { resolveApiBaseUrl };
